(function($) {

	'use strict';

	var init = function() {
        
        if($('.fp-brands__visual__video').length > 0) {

            var $video = $('.fp-brands__visual__video');
            
            initVideo($video);

		    videoTrigger($video);
        }   

    };

    var initVideo = function($video) {

        var root = $video.data('root');

        $(window).resize(function() {

            if($(window).width() >= 768) {
                $video.append('<source src="' + root + '/images/brands.mp4" type="video/mp4">');
            } else {
                $video.append('<source src="' + root + '/images/brands_mobile.mp4" type="video/mp4">');
            }
            $video.prop('preload', 'auto');

        }).resize();

    }
    
    var videoTrigger = function($video) {

        $(window).scroll(function() {

            var windowScroll = $(window).scrollTop();

            var videoOffset = $video.offset().top;
            
            var videoHeight = $video.height();

            var windowHeight = $(window).height();
            
			if((windowScroll >= videoOffset - windowHeight) && (windowScroll <= videoOffset + windowHeight - videoHeight)) {
                $video.trigger('play');
			} else if((windowScroll <= videoOffset - (windowHeight + videoHeight * 0.25)) || (windowScroll >= videoOffset + windowHeight - videoHeight * 2)) {
                $video.trigger('pause');
            }

        }).scroll();

        $(window).on('beforeunload', function() { 
            $video.fadeOut('slow');
        });
    }

	$(document).ready(function() {
		init();
	});

})(jQuery);